import { render, staticRenderFns } from "./Hcactuales.vue?vue&type=template&id=6e90aff4&scoped=true"
import script from "./Hcactuales.vue?vue&type=script&lang=js"
export * from "./Hcactuales.vue?vue&type=script&lang=js"
import style0 from "./Hcactuales.vue?vue&type=style&index=0&id=6e90aff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e90aff4",
  null
  
)

export default component.exports